import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/modules/directives.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { IonicModule } from '@ionic/angular';
import { ConfidentialModalComponent } from './confidential-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    FullHeightContainerModule
  ],
  exports: [ConfidentialModalComponent],
  declarations: [ConfidentialModalComponent]
})
export class ConfidentialModalModule {}
